import React__default, { useCallback } from 'react';
import clsx from 'clsx';
import AudioPlayer, { RHAP_UI } from 'react-h5-audio-player';
import DefaultIcon from '../../DefaultIcon/index.js';
import StyledAudioViewer, { classes } from './index.styles.js';

/**
 * This Audio Viewer is base on the following lib : https://github.com/lhz516/react-h5-audio-player
 *
 * !!! ATTENTION !!!
 * This component use a lib which need a CSS file import
 * If you want to use this component, you'll need to perform the following import :
 * "import "react-h5-audio-player/lib/styles.css";"
 * (need to be installed on the project)
 * @author JBO
 *
 * @param {{ id: any; className: any; testId?: string; file: any; coverImage: any; coverImageMaxHeight: any; coverImageCover: any; displayLoopButton: any; onPlay: any; onPause: any; onEnded: any; }} {
  id,
  className,
  testId = "AudioViewer",
  file,
  coverImage,
  coverImageMaxHeight,
  coverImageCover,
  displayLoopButton,
  onPlay,
  onPause,
  onEnded,
}
 * @returns
 */
var AudioViewer = function (_a) {
    var id = _a.id, className = _a.className, _b = _a.testId, testId = _b === void 0 ? "AudioViewer" : _b, file = _a.file, coverImage = _a.coverImage, coverImageMaxHeight = _a.coverImageMaxHeight, coverImageCover = _a.coverImageCover, hideCover = _a.hideCover, displayLoopButton = _a.displayLoopButton, onPlay = _a.onPlay, onPause = _a.onPause, onEnded = _a.onEnded, _c = _a.KIcon, KIcon = _c === void 0 ? DefaultIcon : _c;
    /**
     *
     * @returns The list of 'custom' controls to display in player
     */
    var computeCustomAdditionalControlsToDisplay = useCallback(function () {
        var customAdditionalControlsToDisplay = [];
        if (displayLoopButton) {
            customAdditionalControlsToDisplay.push(RHAP_UI.LOOP);
        }
        return customAdditionalControlsToDisplay;
    }, [displayLoopButton]);
    /**
     * customIcons to have the MUI icons style
     * TODO : add ripple effect ? how ?
     */
    var customIcons = {
        play: React__default.createElement(KIcon, { className: "fa-regular fa-circle-play" }),
        pause: React__default.createElement(KIcon, { className: "fa-solid fa-circle-pause" }),
        rewind: React__default.createElement(KIcon, { className: "fa-solid fa-backward" }),
        forward: React__default.createElement(KIcon, { className: "fa-solid fa-forward" }),
        volume: React__default.createElement(KIcon, { className: "fa-solid fa-volume" }),
        volumeMute: React__default.createElement(KIcon, { className: "fa-solid fa-volume-slash" }),
        loop: React__default.createElement(KIcon, { className: "fa-solid fa-repeat" }),
        loopOff: (React__default.createElement(KIcon, { sx: { color: function (theme) { return theme.palette.grey[400]; } }, className: "fa-solid fa-repeat" }))
    };
    return (React__default.createElement(StyledAudioViewer, { id: id, className: clsx("AudioViewer", className), "data-testid": testId, coverImageCover: coverImageCover, coverImageMaxHeight: coverImageMaxHeight },
        !hideCover && coverImage && (React__default.createElement("img", { className: clsx("AudioViewerCoverImage", classes.coverImage), src: coverImage, alt: "Cover" })),
        React__default.createElement(AudioPlayer, { className: "AudioPlayerLib", "data-testid": "AudioPlayerLib", src: file, customAdditionalControls: computeCustomAdditionalControlsToDisplay(), onPlay: onPlay, onPause: onPause, onEnded: onEnded, customIcons: customIcons, onPlayError: function (err) { return console.debug("AudioPlayerLib", err); }, key: file })));
};

export { AudioViewer as default };
//# sourceMappingURL=index.js.map
